import { Observable, interval, mergeMap } from 'rxjs';
import checkDeviceRequest from './checkDeviceRequest';
import newCodeRequest from './newCodeRequest';

const REQUEST_REPEAT_TIME = 5000;

const codeObservable = new Observable((subscriber) => {
  newCodeRequest()
    .then((code: string) => {
      subscriber.next({ code, validated: false, newCode: true });
      subscriber.complete();
    })
    .catch(() => {
      subscriber.complete();
    });
});
const checkDevice = (value: string) =>
  interval(REQUEST_REPEAT_TIME).pipe(mergeMap(() => checkDeviceRequest(value)));

export { codeObservable, checkDevice };
